// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"EmailForm_resetButton__2e151"};